import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Button } from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import Header from '../../components/Header';
import { LoadingBar } from '../../components/util/LoadingBar';
import {
  MTAssumptionsSection,
  MTCalc,
  MTCTAv2,
  MTDivider,
  MTHeader,
  MTLearnMore,
  MTLearnMoreItem,
  MTScorePanel,
  MTSkinny,
  MTSubcontent,
  MTSubcontentH1,
  MTSubcontentH2,
  MTSubcontentHR,
  MTSubcontentLabel,
  MTSubcontentP,
  MTSubheading,
  MTWide,
} from '../Microtools/layout';
import { CustomCTA } from '../Onboarding/PlanIntro';

import { runFullSimulation } from '../../actions/simulationActions';
import { trackEvent } from '../../actions/trackEventActions';
import { updateFrame } from '../../actions/uiActions';
import { wlPath, wlVar } from '../../helpers/whitelabel';

// for some reason Chrome on Windows needs a bit of extra height (hence +15px)
const IFrameContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: ${props => (props.height ? `${props.height + 15}px` : '100%')};
`;

const StyledIFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${props => `${props.height}px` || '100%'};
  border: 0;
`;

export class LowerExpenses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iFrameHeight: undefined,
    };
  }

  componentDidMount() {
    this.props.updateFrame('How much does that take-out really cost?', 'homecook_3.jpg');
    // if (!this.props.results) {
    //   this.props.runFullSimulation();
    // }

    // wait for iFrame to load
    this.checkIfIFrameLoaded();
    //window.addEventListener('resize', this.updateIFrameHeight);
  }

  checkIfIFrameLoaded = () => {
    const iFrame = document.getElementById('calc-iframe');
    const iFrameDoc = iFrame.contentDocument || iFrame.contentWindow.document;
    if (iFrameDoc.readyState === 'complete' && iFrameDoc.getElementsByTagName('body').length) {
      // add a listener that will update the height if it's changed
      this.onElementHeightChange(iFrame, this.updateIFrameHeight);
      this.updateIFrameHeight();
      return;
    }
    window.setTimeout(this.checkIfIFrameLoaded, 100);
  };

  onElementHeightChange = (el, callback) => {
    let lastHeight = el.contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
    let newHeight;
    (function run() {
      if (el.contentWindow.document.getElementsByTagName('body').length) {
        newHeight = el.contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
        if (lastHeight != newHeight) {
          callback();
        }
      }

      lastHeight = newHeight;

      if (el.onElementHeightChangeTimer) {
        clearTimeout(el.onElementHeightChangeTimer);
      }

      el.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
  };

  updateIFrameHeight = () => {
    this.setState({
      iFrameHeight: this.getIFrameHeight(),
    });
  };

  getIFrameHeight = () => {
    const newiFrameHeight = document
      .getElementById('calc-iframe')
      .contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
    return newiFrameHeight;
  };

  componentWillUnmount() {
    //window.removeEventListener('resize', this.updateIFrameHeight);
  }

  render() {
    const { results } = this.props;

    if (!results) {
      return <LoadingBar />;
    }

    return (
      <div>
        <MTHeader title="" />
        <MTSkinny>
          <MTSubcontent noCard>
            <MTSubcontentP>
              More important than having a budget, is being able to stick to it! Instead of setting your savings goals
              too high, it’s easier to start with small change like having a home-cooked meal for take-out once week. It
              may not seem like it at first, but over time it can make all the difference to your savings!
            </MTSubcontentP>
          </MTSubcontent>
          <MTSubheading title="Small savings can add up over time" />
          <MTSubcontent noCard>
            <MTSubcontentP>
              The calculator below shows you just how much more you might have in the future if you were to save on a
              few things today. To start, we assumed you cut back on $30 meal out per week until retirement, resulting
              in tens thousands of extra savings after just 10 years!
            </MTSubcontentP>
          </MTSubcontent>
          <MTSubcontent noCard>
            <MTSubcontentP>
              <strong>Have another small expense you’re curious about? Give it a try yourself.</strong>
            </MTSubcontentP>
          </MTSubcontent>

          {/* placeholder for iframe */}
          <IFrameContainer height={this.state.iFrameHeight}>
            <StyledIFrame id="calc-iframe" src="/calculators/lower_expenses" height={this.state.iFrameHeight} />
          </IFrameContainer>

          <MTSubcontent noCard>
            <MTSubcontentP>
              Cutting back on small expenses is just one way that you can start to improve your financial health. If
              you’d like is to share more helpful tips and tools just like this one, just get in touch!
            </MTSubcontentP>
          </MTSubcontent>
        </MTSkinny>
        <CustomCTA heading="We’re here to help you get your savings on track" trackEvent={this.props.trackEvent}>
          <Typography
            tag="div"
            use="body1"
            className="pt-2"
            theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
          >
            Saving is hard, but it’s gets easier when you have back-up. Schedule a free intro and we’ll show you how our
            Cash Flow approach can transform the way you save.
          </Typography>
        </CustomCTA>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    results: state.simulations.results,
  };
}

export default connect(mapStateToProps, { runFullSimulation, trackEvent, updateFrame })(LowerExpenses);
